import firebase from "firebase/app";
import "firebase/firebase-messaging";
import { Capacitor } from "@capacitor/core";

var firebaseConfig = {
  apiKey: "AIzaSyAF397fvoFvKEKv4ziTXsxAYmySmV2w6ds",
  authDomain: "hyreads-86a92.firebaseapp.com",
  projectId: "hyreads-86a92",
  storageBucket: "hyreads-86a92.appspot.com",
  messagingSenderId: "1037447160346",
  appId: "1:1037447160346:web:a45197cae8e01e7a8da7a3",
  measurementId: "G-T1EFGZQWJX",
};

Capacitor.getPlatform() === "web"
  ? firebase.initializeApp(firebaseConfig)
  : null;

export default Capacitor.getPlatform() === "web" ? firebase.messaging() : null;
